import { render, staticRenderFns } from "./ProductSliderWrapper.vue?vue&type=template&id=5cdc1f41"
import script from "./ProductSliderWrapper.vue?vue&type=script&lang=js"
export * from "./ProductSliderWrapper.vue?vue&type=script&lang=js"
import style0 from "./ProductSliderWrapper.vue?vue&type=style&index=0&id=5cdc1f41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports